// extracted by mini-css-extract-plugin
export default {"statusBar":"TopBar_statusBar__2P1sL"};